import { type AnyAction } from 'redux';
import { MY_POSTS_PAGE_TAB_PUBLICATIONS } from '../../constants/my-posts-page';
import { SET_ACTIVE_TAB } from './active-tab-actions';

type State = string;

export default function activeTab(
  state: State = MY_POSTS_PAGE_TAB_PUBLICATIONS,
  action: AnyAction,
): State {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return action.payload;
    default:
      return state;
  }
}
